// Don't modify anything except the last testing one's
const APP_CONSTANTS = {};

APP_CONSTANTS.iceServers = [
  // separate aws stun server
  {
    urls: "stun:13.236.67.5:3478"
  },
  {
    // separate aws turn server
    urls: "turn:52.62.164.177",
    username: "prouser",
    credential: "3TptDG7cAfz5TaXsda"
  },
  {
    // turn server on rebuild staging
    urls: "turn:54.252.245.148",
    username: "prouser",
    credential: "3TptDG7cAfz5TaXsda"
  },
  // stun server on dev
  {
    urls: "stun:3.104.223.138:3478"
  }
];

APP_CONSTANTS.SOCKET_PING_PONG_INTERVAL = 30000;

// For new staging
if (window.location.origin.indexOf("staging") > -1) {
  APP_CONSTANTS.apiUrl = "https://v4-staging-api.instantconsult.com.au";
  APP_CONSTANTS.pmsURL = "https://staging-pr.instantconsult.com.au";
  APP_CONSTANTS.patientURL = "https://staging-patient.instantconsult.com.au";
  APP_CONSTANTS.stripeKey = "pk_test_QZZD3xvNi8fL0FOfkbPhoafE";
} else if (window.location.origin.indexOf("doctor") > -1) {
  // for live
  APP_CONSTANTS.apiUrl = "https://v4-live-api.instantconsult.com.au";
  APP_CONSTANTS.pmsURL = "https://pr.instantconsult.com.au";
  APP_CONSTANTS.patientURL = "https://patient.instantconsult.com.au";
  APP_CONSTANTS.stripeKey = "pk_live_tNEvqj89jEDNsW5SmjhFWF4w";
} else {
  // For testing
  APP_CONSTANTS.apiUrl = "http://localhost:4000";
  // APP_CONSTANTS.apiUrl = "https://v4-staging-api.instantconsult.com.au";
  APP_CONSTANTS.pmsURL = "http://localhost:3003";
  APP_CONSTANTS.patientURL = "http://localhost:3004";
  APP_CONSTANTS.stripeKey = "pk_test_QZZD3xvNi8fL0FOfkbPhoafE";
}

export default APP_CONSTANTS;
